import {gql} from "@irati/utils/gql"

export default gql`
  fragment fullTenantSettings on TenantSettings {
    color
    employeeName
    featureFlags
    hideNormalLogin
    imageLink
    showSSOOptions
    signUpOption
    ssoButtonText
    textColor
    welcomeEmail
  }
`
